<template lang='pug'>
  div
    v-toolbar(dense :flat='showFilters')
      v-tooltip(right v-if='!selected.length')
        template(v-slot:activator='{on}')
          v-btn(v-on='on' @click='showDialog=true' text icon color='primary')
            v-icon add
        span Add Suite
      v-tooltip(right v-if='selected.length')
        template(v-slot:activator='{on}')
          v-btn(v-on='on' @click='deleteSelected()' text icon color='error')
            v-icon delete
        span Delete
      v-spacer
      v-spacer
      filter-button(v-model='showFilters' :badge='filterCount')
      v-text-field(v-model='search' ref='search' placeholder='Search ("/" to focus)' hide-details prepend-inner-icon='search' clearable single-line)
    v-expand-transition.ma-4
      v-card(v-show='showFilters' elevation='0')
        v-card-text
          tags(v-model='tags' label='Filter Tags')
          test-filter(v-model='tests' label='Filter by Test')
    table-list(:headers='headers' :items='testSuites' :total='total' :init-options='tableOptions' :loading='loading' v-model='selected' @update='update')
      template(v-slot:empty)
        v-container(v-if='!loading && !testSuites.length')
          v-row
            v-col(align='center' justify='center')
              .text-h5.grey--text No Suites Defined Yet
              v-btn(text color='accent' @click='showDialog = true') Create Suite
      template(v-slot:row='{item}')
        // <tr> (Gets put inside tr)
        td
          v-row.buttons
            v-tooltip(bottom)
              template(v-slot:activator='{on}')
                v-btn.ma-0(v-on='on' text icon @click.stop.prevent='copyTestSuite(item)')
                  v-icon file_copy
              span Copy
            v-tooltip(bottom)
              template(v-slot:activator='{on}')
                v-btn.ma-0(v-on='on' text icon :to='`/testsuite/${item.guid}`')
                  v-icon mode_edit
              span Edit
            v-tooltip(bottom)
              template(v-slot:activator='{on}')
                v-btn.ma-0(v-on='on' text icon @click.stop='runTestSuite(item)')
                  v-icon play_arrow
              span Run Suite
        td
          router-link(:to='`/testsuite/${item.guid}`') {{item.name}}
        td {{item.description | truncate(40)}}
        td
          display-tags(v-model='item.tags' @tag='appendTag')
        td {{item.baseUrl}}
        td
          v-tooltip(right)
            template(v-slot:activator='{on}')
              span(v-on='on') {{item.createdAt | timeago}}
            span {{item.createdAt | date}}
        td {{item.tests.length}}
        td
          v-icon(small v-if='item.noBrowser') check
        td
          v-icon(small v-if='item.parallel') check
        td {{item.concurrency}}
        td
          v-row(justify='end')
            v-menu(offset-y left)
              template(v-slot:activator='{on}')
                v-btn(text icon v-on='on' @click.native.stop='')
                  v-icon more_vert
              v-list
                v-list-item(@click='deleteTestSuite(item)')
                  v-list-item-title
                    | Delete Suite
        // </tr> (Gets put inside tr)
      template(v-slot:item='{item}')
        v-row(no-gutters)
          v-col(cols='12').text-body-1.pa-3
            .text-subtitle-1 {{item.name}}
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Description:
              v-col {{item.description | truncate(60)}}
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Tags:
              v-col
                display-tags(v-model='item.tags' @tag='appendTag')
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Base URL:
              v-col {{item.baseUrl}}
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Created:
              v-col
                v-tooltip(right)
                  template(v-slot:activator='{on}')
                    span(v-on='on') {{item.createdAt | date}}
                  span {{item.createdAt | timeago}}
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Tests:
              v-col
                | {{item.tests.length}}
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') No Browser:
              v-col
                v-icon(small v-if='item.noBrowser') check
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Parallel:
              v-col
                v-icon(small v-if='item.parallel') check
                span &nbsp;(Concurrency {{item.concurrency}})
            v-row(justify='end')
              v-tooltip(bottom)
                template(v-slot:activator='{on}')
                  v-btn(v-on='on' text icon @click.stop.prevent='copyTestSuite(item)')
                    v-icon file_copy
                span Copy
              v-tooltip(bottom)
                template(v-slot:activator='{on}')
                  v-btn(v-on='on' text icon :to='`/testsuite/${item.guid}`')
                    v-icon mode_edit
                span Edit
              v-tooltip(bottom)
                template(v-slot:activator='{on}')
                  v-btn(v-on='on' text icon @click.stop='runTestSuite(item)')
                    v-icon play_arrow
                span Run Suite
              v-menu(offset-y  left)
                template(v-slot:activator='{on}')
                  v-btn(text icon v-on='on' @click.native.stop='')
                    v-icon more_vert
                v-list
                  v-list-item(@click='deleteTestSuite(item)')
                    v-list-item-title
                      | Delete Suite
        v-divider
    v-dialog(v-model='showDialog' max-width='500px')
      form(@submit.prevent='createTestSuite')
        v-card
          v-card-title
            span.text-h5.primary--text.text--lighten-2 Create Suite
          v-card-text
            v-container(grid-list-md)
              v-text-field(label='Name' v-model='name' required autofocus v-if='showDialog')
              v-textarea(outlined label='Description' v-model='description')
              v-text-field(label='Base URL' v-model='baseUrl' required)
          v-card-actions
            v-spacer
            v-btn(text @click.native='showDialog=false') Cancel
            v-btn(text color='primary' type='submit') Create
</template>

<script>
import _ from 'lodash';
import {mapGetters, mapMutations} from 'vuex';
import {createHelpers} from 'vuex-map-fields';
import Notifications from '../../services/notification.service';
import TestSuite from '../../api/testSuite';
import TestRun from '../../api/testRun';
import TableList from '../../components/TableList';
import BionicMetricsTestStatusIndicator from '../../components/TestStatusIndicator';
import BionicMetricsRunningIndicator from '../../components/RunningIndicator';
import TableMixin from '../../mixins/table.mixin';
import BionicMetricsEnvironments from '../../components/Environments';
import FilterButton from '../../components/FilterButton';
import Tags from '../../components/Tags';
import DisplayTags from '../../components/DisplayTags';
import TestFilter from '../../components/TestFilter';
import FocusMixin from '../../mixins/focus.mixin';
import UtilMixin from '../../mixins/util.mixin';

// We're using the same getter and mutation types
// as we've used in the store above.
const {mapFields} = createHelpers({
  getterType: 'getTestSuiteField',
  mutationType: 'mutateTestSuiteField'
});

export default {
  components: {
    TestFilter,
    DisplayTags,
    Tags,
    FilterButton,
    BionicMetricsEnvironments,
    BionicMetricsRunningIndicator,
    BionicMetricsTestStatusIndicator,
    TableList
  },
  name: 'BionicMetricsTestSuites',
  mixins: [TableMixin, FocusMixin, UtilMixin],
  computed: {
    filterCount() {
      return this.filter.tags.length + this.filter.tests.length;
    },
    ...mapGetters({
      user: 'getUser',
      tableOptions: 'getTestSuiteTableOptions',
      filter: 'getTestSuiteFilter'
    }),
    ...mapFields({
      tags: 'filter.tags',
      tests: 'filter.tests'
    })
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const {list, total} = await TestSuite.list({
          skip: this.skip,
          limit: this.limit,
          sort: this.sort,
          search: this.search,
          tags: this.filter.tags,
          tests: this.filter.tests.map((o) => o.guid)
        });
        this.testSuites = list;
        this.total = total;
      } catch (error) {
        console.error(`Problem getting list of testSuites: ${error.message}`);
        Notifications.errorToast('Error Loading TestSuites', {duration: 30000, retry: this.load});
      }
      this.loading = false;
    },
    async createTestSuite() {
      try {
        const testSuite = await TestSuite.create({
          name: this.name,
          description: this.description,
          baseUrl: this.baseUrl
        });
        this.testSuites.unshift(testSuite);
        this.name = null;
        this.description = null;
        this.baseUrl = null;
        this.showDialog = false;
        this.$router.push(`/testsuite/${testSuite.guid}`);
      } catch (error) {
        console.error(`Error creating test: ${error.message}`);
        Notifications.alert('There was a problem creating the test');
      }
    },
    async copyTestSuite(testSuite) {
      const copy = await TestSuite.copy(testSuite.guid);
      Notifications.toast(`Copied ${testSuite.name}`);
      this.to(`/testsuite/${copy.guid}`);
    },
    async removeTestSuite(guid) {
      await TestSuite.remove(guid);
      const i = this.testSuites.findIndex((ts) => ts.guid === guid);
      this.testSuites.splice(i, 1);
    },
    async deleteTestSuite(testSuite) {
      if (!(await Notifications.confirm('Delete', `Are you sure you want to delete <strong>${testSuite.name}</strong>?`))) return;
      await this.removeTestSuite(testSuite.guid);
      Notifications.toast('Deleted');
    },
    async deleteSelected() {
      if (!(await Notifications.confirm('Delete', `Are you sure you want to delete <strong>${this.selected.length}</strong> suites?`))) return;
      const all = [];
      _.each(this.selected, (testSuite) => {
        all.push(this.removeTestSuite(testSuite.guid));
      });
      await Promise.all(all);
      this.selected = [];
      Notifications.toast('Deleted');
    },
    async runTestSuite(testSuite, suppressToast) {
      try {
        const newRunGuid = await TestRun.create({testSuiteGuid: testSuite.guid});
        if (!suppressToast) Notifications.toast(`Started tests for ${testSuite.name}`);
        this.to(`results/${newRunGuid}`);
      } catch (e) {
        console.error(`Error running Suite: ${e.message}`);
        Notifications.errorToast('Error Running Suite', {duration: 30000, retry: this.load});
      }
    },
    ...mapMutations({
      setTableOptions: 'setTestSuiteTableOptions',
      setFilter: 'setTestSuiteFilter',
      appendTag: 'appendTestSuiteTag'
    })
  },
  watch: {
    // eslint-disable-next-line
    search: _.debounce(function () {
      this.load();
    }, 250),
    // eslint-disable-next-line
    filterCount: _.debounce(function () {
      this.load();
    }, 250)
  },
  data() {
    return {
      search: '',
      selected: [],
      menuToggles: {},
      headers: [
        {text: 'Actions', value: 'actions', sortable: false},
        {text: 'Name', value: 'name'},
        {text: 'Description', value: 'description'},
        {text: 'Tags', value: 'tags', sortable: true},
        {text: 'URL', value: 'baseUrl'},
        {text: 'Created', value: 'createdAt'},
        {text: 'Tests', value: 'tests', sortable: false},
        {text: 'No Browser', value: 'noBrowser', sortable: true},
        {text: 'Parallel', value: 'parallel', sortable: true},
        {text: 'Concurrency', value: 'concurrency', sortable: true},
        {text: '', value: 'moreActions', sortable: false}
      ],
      testSuites: [],
      total: 0,
      skip: 0,
      limit: 10,
      sort: null,
      defaultSort: {name: 1},
      loading: false,
      showDialog: false,
      name: null,
      description: null,
      baseUrl: null,
      showFilters: false
    };
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.buttons {
  width: 200px;
}
</style>
